import { ReactNode } from 'react';
import { Link, LinkProps } from 'react-router-dom';

type TableActionLinkProps = LinkProps & {
  children: ReactNode;
};

/** Botão de texto na coluna Ações de tabelas (navegação). */
export function TableActionLink({ className = '', children, ...props }: TableActionLinkProps) {
  return (
    <Link className={`erp-btn-table-action ${className}`.trim()} {...props}>
      {children}
    </Link>
  );
}
